var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormControlLabel as MuiFormControlLabel, styled, Checkbox as MuiCheckbox, createChainedFunction, checkboxClasses, } from '@mui/material';
import useCheckboxGroup from '../CheckboxGroup/useCheckboxGroup';
function areEqualValues(values, name) {
    var _a;
    return (_a = values === null || values === void 0 ? void 0 : values.includes) === null || _a === void 0 ? void 0 : _a.call(values, name);
}
var Checkbox = styled(MuiCheckbox)(function (_a) {
    var _b;
    var checked = _a.checked;
    return _b = {
            color: 'rgba(0,0,0,.26)'
        },
        _b["&." + checkboxClasses.root] = {
            width: 36,
            height: 36,
            '&:hover': {
                background: 'rgba(76, 175, 80, .08)',
            },
        },
        _b["&." + checkboxClasses.disabled] = __assign({ color: 'rgba(0,0,0,.12)' }, (checked && {
            color: 'rgba(0,0,0,.26)',
        })),
        _b;
});
var FormControlLabelAndCheckbox = React.forwardRef(function (props, ref) {
    var label = props.label, value = props.value, disabled = props.disabled, nameProp = props.name, checkedProp = props.checked, onChangeProp = props.onChange, FormControlLabelProps = props.FormControlLabelProps, CheckboxProps = props.CheckboxProps, sx = props.sx, otherProps = __rest(props, ["label", "value", "disabled", "name", "checked", "onChange", "FormControlLabelProps", "CheckboxProps", "sx"]);
    var checkboxGroup = useCheckboxGroup();
    var checked = checkedProp;
    var onChange = createChainedFunction(onChangeProp, checkboxGroup && checkboxGroup.onChange);
    var name = nameProp;
    if (checkboxGroup) {
        if (typeof nameProp === 'undefined') {
            name = checkboxGroup.name;
        }
        if (typeof checked === 'undefined') {
            checked = areEqualValues(checkboxGroup.value, value);
        }
    }
    // 兼容formItem
    if (typeof checked === 'undefined' && typeof value === 'boolean') {
        checked = value;
    }
    return (React.createElement(MuiFormControlLabel, __assign({ name: name, value: value, onChange: onChange, label: label, checked: checked, disabled: disabled, control: React.createElement(Checkbox, __assign({ ref: ref }, CheckboxProps)) }, FormControlLabelProps, { sx: __assign(__assign({}, sx), { '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                color: 'rgba(0,0,0,0.86)',
            } }) }, otherProps)));
});
FormControlLabelAndCheckbox.defaultProps = {
    label: '',
};
export { Checkbox };
export default FormControlLabelAndCheckbox;
